import { SearchNodeInfoDTO } from 'business/models/Models';
import SearchnFilterService from 'business/services/searchnFilterService';
import React, { useEffect } from 'react';

const searchService = new SearchnFilterService();
interface Props {
  treeNodeId: number;
}
export const SearchAndFilterPanel = (props: Props) => {
  const { treeNodeId } = props;
  const [searchNodeInfo, setSearchNodeInfo] = React.useState<SearchNodeInfoDTO>();

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    searchService
      .getSearchNodeInfo(treeNodeId, signal)
      .then((res) => setSearchNodeInfo(res))
      .catch((err) => {
        if (err.name === 'AbortError') {
          // request was cancelled, ignore
          return;
        }

        throw err;
      });

    return () => {
      abortController.abort();
    };
  }, [treeNodeId]);

  return (
    <div>
      <div id="searchandfilterpanel-title" className="flex flex-col p-3">
        Search and Filter Information
      </div>

      <div id="searchandfilterpanel-search-target" className="flex flex-row p-3">
        <div id="searchandfilterpanel-search-target-title" className="basis-1/3">
          Search Target
        </div>
        <div id="searchandfilterpanel-search-target-name">
          {searchNodeInfo?.targetName}
        </div>
      </div>

      <div
        id="searchandfilterpanel-searched-paths"
        className="flex flex-row p-3 font-semibold"
      >
        Searched Paths
      </div>
      <div
        id="searchandfilterpanel-searched-paths-wrapper"
        className="pl-3 flex flex-col gap-2"
      >
        {searchNodeInfo?.paths?.map((path, i) => (
          <div
            id={`searchandfilterpanel-searched-paths-${i}`}
            key={`search-info-path-${i}`}
          >
            {path}
          </div>
        ))}
      </div>
    </div>
  );
};
